import request from '@/utils/request';
import { API_PREFIX, API_PATHS } from '@/config/api';

// 简单API缓存实现
const apiCache = {
  cache: new Map(),
  cacheRequest: async function(key, promiseFactory) {
    // 检查是否已经有相同请求在进行中
    if (this.cache.has(key)) {
      console.log(`[API缓存] 返回已缓存的请求: ${key}`);
      return this.cache.get(key);
    }

    // 创建新请求并保存到缓存
    console.log(`[API缓存] 发起新请求: ${key}`);
    const promise = promiseFactory();
    this.cache.set(key, promise);

    try {
      // 等待请求完成
      const result = await promise;
      console.log(`[API缓存] 请求成功: ${key}`);
      return result;
    } catch (error) {
      // 如果请求失败，从缓存中移除，以便下次重试
      console.log(`[API缓存] 请求失败: ${key}`, error);
      this.cache.delete(key);
      throw error;
    }
  },
  clearCache: function() {
    this.cache.clear();
    console.log('[API缓存] 已清空');
  }
};

/**
 * 获取当前登录用户的个人信息
 * @returns {Promise} 返回Promise对象
 */
export function getUserProfile() {
  const cacheKey = 'user_profile';
  
  return apiCache.cacheRequest(cacheKey, () => {
    console.log('[getUserProfile] 获取个人信息');
    return request({
      url: '/api/v1/profile/info',
      method: 'get'
    });
  });
}

/**
 * 获取教师列表
 * @param {Object} params - 查询参数
 * @param {string} params.campus_code - 校区编码
 * @param {number} params.skip - 跳过数量
 * @param {number} params.limit - 限制数量
 * @param {string} params.real_name - 教师姓名（可选，用于筛选）
 * @returns {Promise} 返回Promise对象
 */
export function getTeachers(params = {}) {
  const cacheKey = `teachers_${JSON.stringify(params)}`;
  
  return apiCache.cacheRequest(cacheKey, () => {
    console.log('[getTeachers] 请求参数:', params);
    return request({
      url: API_PREFIX + API_PATHS.TEACHER.LIST,
      method: 'get',
      params
    });
  });
}

/**
 * 获取学生列表
 * @param {Object} params - 查询参数
 * @param {string} params.campus_code - 校区编码
 * @param {number} params.skip - 跳过数量
 * @param {number} params.limit - 限制数量
 * @param {string} params.real_name - 学生姓名（可选，用于筛选）
 * @returns {Promise} 返回Promise对象
 */
export function getStudents(params = {}) {
  const cacheKey = `students_${JSON.stringify(params)}`;
  
  return apiCache.cacheRequest(cacheKey, () => {
    console.log('[getStudents] 请求参数:', params);
    return request({
      url: API_PREFIX + API_PATHS.STUDENT.LIST,
      method: 'get',
      params
    });
  });
}

// 导出缓存清理函数
export function clearUserCache() {
  apiCache.clearCache();
}

/**
 * 修改用户密码
 * @param {Object} data - 请求体参数
 * @param {string} data.old_password - 旧密码
 * @param {string} data.new_password - 新密码
 * @returns {Promise} 返回Promise对象
 */
export function changePassword(data) {
  console.log('[changePassword] 修改密码');
  
  // 修改密码后应清除缓存
  apiCache.clearCache();
  
  return request({
    url: '/api/v1/profile/password',
    method: 'put',
    data
  });
} 